import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepositosService {
  private ENDPOINT = environment.ENDPOINTS.DEPOSITO;

  constructor(
    private http: HttpClient
  ) { }

  saveDeposito(data: any) {
    return this.http.post<any>(`${this.ENDPOINT}`, data);
  }


  getDepositos(id_caseta: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }`);
  }


}
